import { ActionBarPrimitive } from '@assistant-ui/react';
import { Button } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

import { ErrorFallback } from '#core/components/error/ErrorFallback.tsx';

/**
 * Error fallback for assistant message errors.
 * Composes core ErrorFallback with assistant-ui retry action.
 */
export function ChatErrorFallback() {
  return (
    <ErrorFallback
      error="The assistant couldn't complete your request. You can try again or rephrase your message."
      retryAction={
        <ActionBarPrimitive.Reload asChild>
          <Button leftSection={<IconRefresh size={14} />} size="xs" variant="light">
            Retry
          </Button>
        </ActionBarPrimitive.Reload>
      }
      showDetails={false}
      showRetry
      title="Something went wrong"
      variant="alert"
    />
  );
}
